module.exports = __webpack_public_path__ + "static/media/uni-logo.b8da8c68.png";